














































































































import ModalMixin from '@/mixins/modal.mixin';
import { CrsForm } from '@resclick/crs-ui';
import { compass } from '@resclick/compass';
import { Component, Mixins, Watch } from 'vue-property-decorator';

const updateUserFields = {
  isActive: true,
  name: '',
  surname: '',
  email: '',
  role: '',
  company: '',
  type: 'ADMIN',
};

const createUserFields = {
  ...updateUserFields,
  locale: 'en-US',
  password: '',
  repeat: '',
  type: 'ADMIN',
};

@Component
export default class UserModal extends Mixins(ModalMixin) {
  form!: CrsForm<'users', 'create' | 'update'>;

  @Watch('mode', { immediate: true })
  switchForm(mode: 'create' | 'update') {
    this.form = this.$crsForm('users', mode, mode === 'create' ? createUserFields : (updateUserFields as any));
  }

  async getForm() {
    return compass.do('users', 'findOne', { params: { id: this.id } });
  }
}
